"use strict";

const order = [
	"POI",
	"ROUTE_DEFAULT_STROKE",
	"ROUTE_START_END_MARKER",
	"ROUTE_DEFAULT",
	"ROUTE_SECTION_SELECTED_STROKE",
	"ROUTE_SECTION_SELECTED",
	"ROUTE_SECTION_HIGHLIGHTED_STROKE",
	"ROUTE_SECTION_HIGHLIGHT",
	"HIGHLIGHTED_ROUTE_START_END_MARKER",
	"ROUTE_SECTION_TRANSPARENT",
	"ROUTE_POINTER",
	"IGNITION_OFF",
	"IGNITION_ON",
	"MOVING",
	"FOCUSED",
	"SELECTED",
	"POI_CROSSING_MARKER",
	"HIGHLIGHTED_POI_CROSSING_MARKER",
	"TOOLTIP",
	"CONTEXT_MENU"
];

const zIndexMap = {};

order.forEach((layer, index) => zIndexMap[layer] = index);

export default zIndexMap;


// WEBPACK FOOTER //
// ./src/view/Map/zIndex.js